export default __webpack_public_path__ + "static/media/back1.c3e782c2.jpg";